const layerStyles = {
  base: {
    bg: "brand.900",
    borderRadius: "2xl",
    borderColor: "gray.500",
    py: 6,
    px: 8,
    pt: 5
  },
  card: {
    bg: "brand.800",
    borderRadius: "2xl",
    borderColor: "gray.500",
    px: [4, 6, 8],
    pt: [3, 4, 5],
    pb: [4, 5, 6]
  }
};

export default layerStyles;
